import { Play } from 'lucide-react';
import { Button } from '../ui/button';
import './MoleculeVideo.css';

export const MoleculeVideo = ({ playback }) => {
  const { videoRef, source, poster, canRun, hasPlayed, onPlaying, onPause, onError } = playback;
  return <div className="hero-background-layer" data-testid="hero-background-layer" aria-hidden="true">
    <video ref={videoRef} id="betaris-molecule-video" data-testid="molecule-video" className="hero-background-video"
      src={source || undefined} autoPlay={canRun} muted loop playsInline preload="none" poster={poster}
      onPlaying={onPlaying} onPause={onPause} onError={onError}
      disablePictureInPicture disableRemotePlayback controlsList="nodownload nofullscreen noremoteplayback" />
    <img src={poster} width="1920" height="800" alt="" fetchPriority="high" data-testid="molecule-poster"
      className={`hero-background-poster ${hasPlayed ? 'poster-has-played' : ''}`} />
    <div className="hero-readability-gradient" />
  </div>;
};

export const MoleculeControls = ({ playback }) => {
  const { playing, canRun, blocked, error, start } = playback;
  const needsStart = !playing && (!canRun || blocked || error);
  const label = error ? 'Video erneut starten' : 'Animation starten';
  return <>
    <div className="molecule-controls">
      {needsStart && <Button type="button" variant="ghost" className="molecule-toggle" onClick={start} data-testid="molecule-start-button"
        aria-label={label} aria-controls="betaris-molecule-video">
        <Play size={13} aria-hidden="true" />
        <span>{error ? 'Erneut starten' : 'Abspielen'}</span>
      </Button>}
      <span className="molecule-duration" data-testid="molecule-duration">12 S · LOOP</span>
    </div>
    <p className="sr-only" aria-live="polite" data-testid="molecule-playback-status">{playing ? 'Video läuft automatisch in Endlosschleife.' : error ? 'Das Video konnte nicht geladen werden. Das Vorschaubild bleibt sichtbar. Sie können erneut starten.' : blocked ? 'Automatische Wiedergabe blockiert. Starten Sie das Video über die Abspielen-Taste.' : needsStart ? 'Bewegungsarme Darstellung aktiv. Auf Wunsch können Sie die Animation starten.' : 'Die Animation startet automatisch.'}</p>
    {error && <p className="molecule-error" role="status" data-testid="molecule-video-error">Video nicht verfügbar. Das Vorschaubild bleibt sichtbar. Über „Erneut starten“ erneut versuchen.</p>}
  </>;
};